import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { useRfiForm } from '../../RfiFormProvider';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../constants/issue-attribute-names';
import { RfiCreateFormValues } from '../../types';
import { PureRfiTypeField } from './PureRfiTypeField';
import { Assignee } from '../../../sdk';
import { usePopulateRfiTypeFields, FieldSetters } from '../../../hooks/usePopulateRfiTypeFields';

export const RfiType = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { mandatoryFields, refs } = useRfiForm();
  const fieldName = ISSUE_ATTRIBUTE_NAMES.RFI_TYPE_ID;
  const isFieldsMandatory = mandatoryFields.includes(fieldName);
  const errorMessage = formik.touched[fieldName] && formik.errors[fieldName];
  const selectedRfiTypeId = formik.values[fieldName];

  const setRfiType = (id: string) => {
    formik.setFieldValue(fieldName, id);
  };

  const fieldSetters: FieldSetters = useMemo(() => {
    const getFieldSetter =
      (fieldName: string) => (value: string | string[] | Date | null | Assignee[]) =>
        formik.setFieldValue(fieldName, value);
    return {
      assignedTo: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO),
      locationDescription: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION),
      reference: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.SUB_ID),
      costImpact: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.COST),
      scheduleImpact: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.SCHEDULE),
      priority: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.PRIORITY),
      category: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.CATEGORY),
      discipline: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.DISCIPLINE),
      dueDateOffset: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.DUE_DATE),
      watchers: getFieldSetter(ISSUE_ATTRIBUTE_NAMES.WATCHERS),
    };
  }, []);

  usePopulateRfiTypeFields({ selectedRfiTypeId, fieldSetters, formStatus: formik.values.status });

  return (
    <PureRfiTypeField
      ref={refs[fieldName]}
      required={isFieldsMandatory}
      errorMessage={errorMessage}
      selectedRfiTypeId={selectedRfiTypeId}
      setRfiType={setRfiType}
      showDiagrams={false}
    />
  );
};
